import { gql } from '@apollo/client';

/**
 * CREATE_INVOICE_PDF_MUTATION
 * 
 * Creates a PDF for a card invoice
 * 
 * @param id - The invoice ID (integer)
 * 
 * @returns PDF data containing URL and expiration date
 */
export const CREATE_INVOICE_PDF_MUTATION = gql`
	mutation CreateCardInvoicePdf($id: Int!) {
		createCardInvoicePdf(input: { id: $id }) {
			pdfData {
				url
				expirationDate
			}
		}
	}
`;
